import { create } from 'zustand';
import { api } from '@/lib/api';
import type { OnlineFriend, BirthdayFriend, FriendSuggestion } from '@shared/types';

interface SocialState {
  onlineFriends: OnlineFriend[];
  birthdays: BirthdayFriend[];
  suggestions: FriendSuggestion[];
  loadingOnline: boolean;
  loadingBirthdays: boolean;
  loadingSuggestions: boolean;

  fetchOnlineFriends: () => Promise<void>;
  fetchBirthdays: () => Promise<void>;
  fetchSuggestions: () => Promise<void>;
}

export const useSocialStore = create<SocialState>((set, get) => ({
  onlineFriends: [],
  birthdays: [],
  suggestions: [],
  loadingOnline: false,
  loadingBirthdays: false,
  loadingSuggestions: false,

  fetchOnlineFriends: async () => {
    if (get().loadingOnline) return;
    set({ loadingOnline: true });
    try {
      const friends = await api.get<OnlineFriend[]>('/friends/online');
      set({ onlineFriends: friends, loadingOnline: false });
    } catch {
      set({ loadingOnline: false });
    }
  },

  fetchBirthdays: async () => {
    if (get().loadingBirthdays) return;
    set({ loadingBirthdays: true });
    try {
      const bdays = await api.get<BirthdayFriend[]>('/friends/birthdays');
      set({ birthdays: bdays, loadingBirthdays: false });
    } catch {
      set({ loadingBirthdays: false });
    }
  },

  fetchSuggestions: async () => {
    if (get().loadingSuggestions) return;
    set({ loadingSuggestions: true });
    try {
      const suggestions = await api.get<FriendSuggestion[]>('/friends/suggestions');
      set({ suggestions, loadingSuggestions: false });
    } catch {
      set({ loadingSuggestions: false });
    }
  },
}));
